import { gql } from 'apollo-boost'

const REFRESH_ACCESS_TOKEN = gql`
  mutation refreshAccessToken($refreshToken: String!) {
    refreshAccessToken(refreshToken: $refreshToken)
  }
`

export default REFRESH_ACCESS_TOKEN
